import React, { useEffect, useState } from "react";
import { IoWarning } from "react-icons/io5";
import { LuArrowRight, LuCalendarDays } from "react-icons/lu";
import { Link } from "react-router-dom";
import "../../css/items.scss";
import { serverInstance } from "../../service/axios";
import Dimmer from "../shared/Dimmer";
import "./posts.scss";

const PostList = ({ data }) => {
  const [allItems, setAllItems] = useState([]);
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);
  const [errorMsg, setErrorMsg] = useState("");
  const [currentPage, setCurrentPage] = useState(1);
  const [itemsPerPage] = useState(9);

  // Get current items
  const indexOfLastItem = currentPage * itemsPerPage;
  const indexOfFirstItem = indexOfLastItem - itemsPerPage;
  const currentItems = filteredData.slice(indexOfFirstItem, indexOfLastItem);

  // Calculate total pages
  const totalPages = Math.ceil(filteredData.length / itemsPerPage);

  // Change page
  const handlePageChange = (pageNumber) => setCurrentPage(pageNumber);

  useEffect(() => {
    window.scrollTo(0, 0);

    serverInstance.get("/app/posts")
      .then(res => {
        res.data.items.sort((a, b) => new Date(b.created_at).getTime() - new Date(a.created_at).getTime());
        setAllItems(res.data.items)
        setFilteredData(res.data.items)
        setErrorMsg("");
        setLoading(false);
      })
      .catch((err) => {
        setErrorMsg(err);
        setLoading(false);
      })
  }, []);

  const getPageNumbers = () => {
    const pageNumbers = [];
    if (totalPages <= 5) {
      // Show all pages if total is 5 or less
      for (let i = 1; i <= totalPages; i++) {
        pageNumbers.push(i);
      }
    } else {
      // Show limited pages with ellipsis
      if (currentPage <= 3) {
        for (let i = 1; i <= 3; i++) {
          pageNumbers.push(i);
        }
        pageNumbers.push('...');
        pageNumbers.push(totalPages);
      } else if (currentPage >= totalPages - 2) {
        pageNumbers.push(1);
        pageNumbers.push('...');
        for (let i = totalPages - 2; i <= totalPages; i++) {
          pageNumbers.push(i);
        }
      } else {
        pageNumbers.push(1);
        pageNumbers.push('...');
        pageNumbers.push(currentPage - 1);
        pageNumbers.push(currentPage);
        pageNumbers.push(currentPage + 1);
        pageNumbers.push('...');
        pageNumbers.push(totalPages);
      }
    }
    return pageNumbers;
  };

  return (
    <div id="posts" className='items-container'>
      {loading ? <Dimmer /> : null}
      
      <section className="upper-section">
        <div className="upper-section-inner">
          <div className="title-container">
            <h2>{data.title}</h2>
          </div>
        </div>
      </section>
      
      {errorMsg ? <div className="error-msg">
        <IoWarning />
        &nbsp;
        {errorMsg}
      </div> : null}

      <section className="posts col-11">
        {!loading && allItems.length > 0 ?
          currentItems.map((item) => {
            const detailPath = "/posts/" + item.id;
            const imagePath = item.fileUrl
              ? `https://msid-asset.s3.ap-northeast-2.amazonaws.com/${item.fileUrl}`
              : "";
            const formattedDate = item.created_at
              ? new Date(item.created_at).toLocaleDateString("mn-MN", {
                year: "numeric",
                month: "long",
                day: "numeric"
              })
              : "";

            return (
              <article key={"post-" + item.id} className="post-item">
                {imagePath ? (
                  <Link className="post-img" to={detailPath} aria-label={item.title}>
                    <img src={imagePath} alt={item.title} />
                  </Link>
                ) : null}
                <div className="post-info">
                  <Link className="post-name" to={detailPath}>
                    {item.title}
                  </Link>
                  {item.description ? (
                    <div className="post-desc max-line-3">
                      {item.description}
                    </div>
                  ) : null}
                  {formattedDate ? (
                    <div className="post-meta">
                      <div className="post-time">
                        <LuCalendarDays aria-hidden="true" />
                        <span>{formattedDate}</span>
                      </div>
                    </div>
                  ) : null}
                  <Link className="archive-card-link" to={detailPath}>
                    <span>{data.open}</span>
                    <LuArrowRight aria-hidden="true" />
                  </Link>
                </div>
              </article>
            );
          })
          :
          !loading ? (
            <div className="archive-empty-state">
              {data.noData}
            </div>
          ) : null
        }
      </section>

      {!loading && totalPages > 1 ? (
        <div className="pagination d-flex justify-content-center flex-wrap">
          <button
            onClick={() => handlePageChange(currentPage - 1)}
            disabled={currentPage === 1}
            className="pagination-btn mx-1">
            {"<"}
          </button>

          {getPageNumbers().map((number, index) => (
            <button
              key={index}
              onClick={() => number !== '...' ? handlePageChange(number) : null}
              className={`pagination-btn mx-1 ${currentPage === number ? 'active' : ''} ${number === '...' ? 'dots' : ''}`}
            >
              {number}
            </button>
          ))}

          <button
            onClick={() => handlePageChange(currentPage + 1)}
            disabled={currentPage === totalPages}
            className="pagination-btn mx-1">
            {">"}
          </button>
        </div>
      ) : null}
    </div>
  );
};
export default PostList;
